<app-guest>
  @if (!submitted) {
    <form [formGroup]="form" (ngSubmit)="onSubmit()">
      <h2 class="fw-bold fs-5 text-center mb-3">Password lost</h2>
      <div class="mb-3">
        <label for="email" class="form-label fw-bold">Enter your email address</label>
        <input type="email" class="form-control" id="email" placeholder="example@example.com" formControlName="email">
      </div>
      <div class="d-grid mb-3">
        <button type="submit" class="btn btn-primary fw-bold p-lg-3" [disabled]="form.invalid">Send Reset Link</button>
      </div>
      <div class="text-center small">Already have an account? <a routerLink="/login">Sign in</a></div>
    </form>
  }

  @if (submitted) {
    <div class="card-body text-center">
      <i class="bi bi-check-circle-fill text-success display-4"></i>
      <h1 class="fw-bold fs-5 mt-3">An email with a password reset link has been sent.</h1>
      <p class="text-muted">Please click the link in the email to reset your password.</p>
      <a routerLink="/login" class="btn btn-primary fw-bold p-lg-3">Return to login</a>
    </div>
  }
</app-guest>
